const a=Array(25).fill("none");export{a as default};
//# sourceMappingURL=shadowsV2.js.map
